export const ERRORS = (error) => {
    const errors = {
        invalid_grant:
            'Your connection has expired or needs to be refreshed. Please reconnect your account to continue.',
    };

    return (errors[error] || error) ?? 'Something went wrong';
};
